import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { base_url_toonflix } from "../Services/api";
import img from '../assets/mad.png'
import Select from 'react-select';
import Lottie from 'lottie-react'
import loader from '../Animations/Loader.json'

const GetHeaders = () => {

  const navigate = useNavigate();
  const [show,setShow] = useState(false);
    const [tVal,setTVal] = useState(null)


  const [selectedOption, setSelectedOption] = useState({ value: 'daily', label: 'Tous les jours/100 FCFA' })
  const [loading,setLoading] = useState(false)
  
  // const number = Cookies.get('number')

  const urlParams = new URLSearchParams(window.location.search);
  const msisdn = urlParams.get('msisdn');
  var ExtId = urlParams.get('extId');
  console.log(msisdn,"==paramsmsisdn===")
  // Cookies.set('number',msisdn);
  // Cookies.set('extId',ExtId)
 


  const options = [
    { value: 'daily', label: 'Tous les jours/100 FCFA' },
    { value: 'weekly', label: 'Hebdomadaire/300 FCFA' },
    { value: 'monthly', label: 'Mensuelle/500 FCFA' },
  ];

    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray', // Change border color here
        boxShadow: state.isFocused ? '0 0 0 1px rgb(234 88 12)' : 'none', // Optional: Add box shadow
        '&:hover': {
          borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray', // Change border color on hover
        },
      
      }),
      // You can customize other parts of the select component as well
    };

   const getScript = async () => {
      setLoading(true);
    try {
       const res = await axios.post(
      `${base_url_toonflix}/api/v1/evina/script`,
        {
        serviceName: "MadFunny",
        extId: ExtId,
        }
      );
    // parse once, reuse everywhere
    const parsed = typeof res.data?.response === 'string'
      ? JSON.parse(res.data.response)
      : res.data?.response;

    // console.log(parsed, "==parsed response==");

      const scriptContent = parsed?.s;
       const token = parsed?.t;
       setTVal(token || "");

    if (!scriptContent) {
      console.log("No script content found");
      return;
    }

    let top_head = document.getElementsByTagName("head")[0];
    let anti_script = document.createElement("script");

    anti_script.innerHTML = scriptContent;
    top_head.insertBefore(anti_script, top_head.firstChild);

    const event = new Event("DCBProtectRun");
    document.dispatchEvent(event);

    document.addEventListener("gateway-load", (event) => {
      console.log(event, "EVENT LOADED");
    });

  } catch (error) {
    console.error("Error fetching script", error);

    const status = error?.response?.status;
    const msg = error?.response?.data?.message;

    if (status === 400) {
      console.log("Invalid script request payload:", msg);
    } else if (status === 500) {
      console.log("Server error generating script:", msg);
    }

  } finally {
     setLoading(false);
        setShow(true);
  }
};
   
    useEffect(()=>{
        getScript()
     },[])

   
     const handle = async (e) => {
          e.preventDefault();
          setLoading(true)
      const data = {
          msisdn: msisdn,
           packType: selectedOption.value,
           extId: ExtId,
            t: tVal,
           serviceName: "MadFunny"
    }

  try {
    const res = await axios.post(`${base_url_toonflix}/api/v1/subscribe`, data);
    // console.log(res.data);

    if (res.data?.statusCode === 200 && res.data?.code === 'SUCCESS') {

      toast.success(res.data?.message || "Abonnement réussi !");
       Cookies.set('number', msisdn, { expires: 6/24 }); // 6 hours
  Cookies.set('extId', ExtId, { expires: 6/24 });

      setTimeout(() => {
      navigate(`/redirect?msisdn=${msisdn}`)
        // window.location.href='https://highfivesgames.com/#/home'
      }, 1000)
      } else if (res.data?.statusCode === 200 && res.data?.code === 'BILLING_PENDING') {

      toast.info(res.data?.message || "Facturation en attente.");

    } else {

      toast.error(res.data?.message || "Échec de l'abonnement");
    }

  }

  catch (err) {
    console.log(err, 'error------in subscribing')

    const status = err?.response?.status;
    const msg = err?.response?.data?.message;
    const code = err?.response?.data?.code;

    if (status === 409 && code === 'ACTIVE_SUBSCRIPTION') {
      toast.info(msg || "Abonnement déjà actif.");
      Cookies.set('number', msisdn, { expires: 6/24 });
      Cookies.set('extId', ExtId, { expires: 6/24 });
      navigate(`/redirect?msisdn=${msisdn}`);
    } else if (status === 400) {
      toast.error(msg || "Requête invalide, veuillez réessayer.");
    } else if (status === 500) {
      toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.");
    } else {
      toast.error(msg || "Une erreur s'est produite");
    }
  }
  // catch (err) {
  //   console.log(err, 'error------in subscribing')

  //   const status = err?.response?.status;
  //   const msg = err?.response?.data?.message;

  //   if (status === 400) {
  //     toast.error(msg || "Requête invalide, veuillez réessayer.");
  //   } else if (status === 500) {
  //     toast.error(msg || "Erreur serveur, veuillez réessayer plus tard.");
  //   } else {
  //     toast.error(msg || "Une erreur s'est produite");
  //   }
  // }

  // Cookies.set('number', msisdn);
  setLoading(false)

};



  return (
    <div className='bg-black min-h-screen flex justify-center items-center'>
      {/* <ToastContainer/> */}
      {
      show ? 
      <>
      <div className="container mx-auto max-w-screen-sm bg-white rounded-md p-4 md:p-8 flex flex-col items-center shadow-lg relative">
      <img
        src={img}
        alt="/"
        className="w-24 h-auto mb-4 md:mb-0 md:w-[200px]"
      />
      <form className="flex flex-col w-full md:w-2/3 px-4 py-4 md:py-8">
        <div className="text-center">
          <h1 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">
           
              
          Sélectionnez le
           
            <span className="text-orange-600 font-bold text-2xl md:text-3xl px-2">
            Type de paquet

            </span>
          </h1>
          <p className='text-black text-sm mt-1 font-medium '>
          MadFunny est un portail de mèmes proposant des mèmes amusants et du contenu viral pour un divertissement et des rires quotidiens.

          </p>


          
        </div>
        {/* <br /> */}
        <p className='py-2 pt-4 text-lg font-semibold'>Type de paquet</p>
        <Select
      defaultValue={selectedOption}
      onChange={setSelectedOption}
      options={options}
      styles={customStyles}
    />
        {/* {error && <p className="text-red-600 text-center mt-2">{error}</p>} */}
        <div className="flex mt-4 md:mt-6">
          <button
            onClick={handle}
            id="otp-send"
            type='submit'
            className="w-full bg-orange-600 text-white py-2 px-4 rounded"
            disabled={loading}
          >
            {loading ? "Soumission..." : "s'abonner"}
          </button>
           
        </div>
     <p 
      onClick={() => navigate('/tnc')} 
       className="text-blue-400 text-center mt-4 underline cursor-pointer"
       >
      Conditions générales
    </p>
         <span className='text-xs font-semibold w-full text-center' >• Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-direpanz.support1@panzcon.com</span>
      </form>
      
      
    </div>
      </>
      :
      <>
        <Lottie
          animationData={loader}
        />
      </>
      

    }
    </div>
  )
}

export default GetHeaders



